<template>
  <div class="partners-component">
    <img
      class="partners-img"
      :data-not-lazy="true"
      :width="isMobile ? 325 : 1252"
      :height="isMobile ? 132 : 54"
      v-lazy-load :data-src="isMobile ? touchImage.url : webImage.url"
      :alt="isMobile ? touchImage.webAltInfo : webImage.webAltInfo"
    >
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style lang="scss" scoped>
.partners-component {
  width: 100%;
  background: #fff;
  padding: 15px 0;
  display: flex;
  align-content: center;
  justify-content: center;

  .partners-img {
    width: 909px;
    height: 40px;
  }
}

// @media (min-width: 1280px) and (max-width: 1439px) {
//   .partners-component {

//     .partners-img {
//       width: 1150px;
//       height: 50px;
//     }
//   }
// }

@media (min-width: 769px) and (max-width: 1279px) {
  .partners-component {
    .partners-img {
      width: 769px;
      height: 33px;
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .partners-component {
    background: #fff;
    width: 100%;
    padding: 8.267vw 0;

    .partners-img {
      width: 86.667vw;
      height: 35.467vw;
    }
  }
}
</style>
